import { useEffect } from "react";

/**
 * Closes a modal when the user presses Escape.
 *
 * Companion to useModalBackdropClose for keyboard users. Pass `enabled: false`
 * to suspend it — e.g. while the modal is closed, or while a request is in
 * flight and the modal must not close underneath it.
 */
export function useEscapeClose(onClose: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose, enabled]);
}
